import $ from 'jquery';
import { Pagination, Autoplay, Mousewheel, EffectFade } from 'swiper/modules';
import {Swiper} from 'swiper'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

Swiper.use([Pagination, Autoplay, Mousewheel, EffectFade])

let HeroSlider = $('.js-slider-highlights');

if (HeroSlider.length > 0) {
  HeroSlider.each(function () {
    let HeroSliderSwiper = new Swiper(this, {
      slidesPerView: 1,
      loop: true,
      speed: 500,
      effect: 'fade',
      autoplay: {
        delay: 5000,
        disableOnInteraction: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },

      breakpoints: {
        768: {
          autoHeight: true,
        },
      },
    });

    $(this).mouseenter(function () {
      (this).swiper.autoplay.stop();
    });

    $(this).mouseleave(function () {
      (this).swiper.autoplay.start();
    });

    HeroSliderSwiper.init();
  });
}

